import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api, fmtZAR, formatApiError } from '../lib/api';
import { useAuth } from '../lib/auth-context';

const AdminCatalog = () => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');

  const load = async () => {
    const r = await api.get('/admin/catalog');
    setRows(r.data.items || []);
  };
  useEffect(() => { load(); }, []);

  const patch = async (id, body) => {
    setErr('');
    try { await api.patch(`/admin/catalog/offering/${id}`, body); await load(); }
    catch (e) { setErr(formatApiError(e)); }
  };

  const isOwner = user?.role === 'OWNER';

  return (
    <AdminShell title="Academic catalog">
      {!isOwner && <p className="text-xs text-[#4B5563] mb-4">Pricing changes are restricted to Owners.</p>}
      {err && <p className="text-sm text-red-600 mb-3" data-testid="catalog-error">{err}</p>}
      <div className="grid md:grid-cols-2 gap-4" data-testid="catalog-grid">
        {rows.map((o) => (
          <div key={o.id} className="bg-white rounded-2xl border border-black/5 p-5" data-testid={`catalog-offering-${o.id}`}>
            <div className="flex items-start justify-between gap-3 mb-3">
              <div>
                <p className="text-xs font-mono tracking-wider text-[#D4A017]">{o.curriculum} · {o.grade_band}</p>
                <h3 className="text-lg font-bold text-[#1B2A41]" style={{ fontFamily: 'Outfit' }}>{o.grade_band}</h3>
              </div>
              <div className="text-right">
                <p className="text-2xl font-black text-[#1F6F4A]">{fmtZAR(o.price_cents)}</p>
                <p className="text-xs text-[#4B5563]">/ subject / mo</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5 mb-4">
              {o.subjects.map((s) => <span key={s} className="text-xs px-2 py-1 bg-[#F3F5F2] rounded-full">{s}</span>)}
            </div>
            <div className="flex items-center justify-between pt-3 border-t border-black/5">
              <label className="flex items-center gap-2 text-sm text-[#1B2A41]">
                <input type="checkbox" checked={o.active} disabled={!isOwner} onChange={(e) => patch(o.id, { active: e.target.checked })} data-testid={`toggle-active-${o.id}`}/>
                Accepting registrations
              </label>
              {isOwner && (
                <div className="flex items-center gap-2">
                  <span className="text-xs text-[#4B5563]">R</span>
                  <input
                    type="number" min={0}
                    defaultValue={o.price_cents / 100}
                    onBlur={(e) => {
                      const next = Math.round(parseFloat(e.target.value) * 100);
                      if (!Number.isNaN(next) && next !== o.price_cents) patch(o.id, { price_cents: next });
                    }}
                    className="w-24 apc-input !py-1"
                    data-testid={`price-input-${o.id}`}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <style>{`.apc-input { padding:0.4rem 0.6rem; border-radius:8px; border:1px solid rgba(27,42,65,0.15); background:#fff; font-size:0.85rem; }`}</style>
    </AdminShell>
  );
};

export default AdminCatalog;
